module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.5@core-js/library/modules/_library.js
// module id = 98
// module chunks = 0